(function() {
    var $wrapper = SR.dom.$wrapper;
    var API = SR.data.customerServiceAPI;
    var appcid = SR.util.urlParam('appcid');
    var sn = SR.permissions.sn;
    var uid = SR.data.guid || SR.data.jsid;
    var xhrTimeout = 3000;

    // 发送消息
    function sendMsg(content, type, successCb, errorCb) {
        if (!appcid || !appcid.length || !sn || !sn.length || !content || !content.length) {
            return;
        }
        var msgType = type || 'text';
        $.ajax({
            method: 'POST',
            timeout: xhrTimeout,
            url: API + '/send',
            data: {
                appcid: appcid,
                sn: sn,
                uid: uid,
                msgType: msgType,
                content: content,
            }
        }).done(function(data) {
            if (data.ret === 0) {
                successCb && successCb(data);
            } else {
                errorCb && errorCb(data);
            }
        }).fail(function(err) {
            errorCb && errorCb(err);
        })
    }

    window.sendEmoticon = function(eid, options) {
        var emoticonId = 'emoticonId-' + Date.now();
        var options = options || {};
        var $answerContainer = options.answerContainerId ? $('#' + options.answerContainerId) : $wrapper;
        var templateHTML = template('emoticon', {
            id: emoticonId,
            avatar: SR.data.userInfo.userAvatar,
            emoticonUrl: '',
        });
        $answerContainer.append(templateHTML);

        sendMsg(eid, 'emoticon', function() {
            
        }, function(err) {
            
        });
    }
})();